import React, { useEffect, useState } from 'react';
import {
  Link as RouterLink,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';

import {
  Box,
  Button,
  ButtonBase,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import { getFormattedDate } from '../../../../helpers/getDate';
import { getAccesories } from '../../../../services/policy/policy.service';
import SendEmail from '../Components/SendEmail.component';

const Policy = () => {
  const { loading, policy, getPolicyById } = useVehiclesContext();
  const { id } = useParams<any>();
  const history = useHistory();
  const [details, setDetails] = useState([]);
  const [loadingHelper, setLoaderhelper] = useState(false);
  const [dialog, setDialog] = useState(false);
  const { user } = useAuthDataContext();
  const { state } = useLocation<any>();

  useEffect(() => {
    dataLayerPush('Documentacion_poliza', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      if (policy.id !== Number(id)) {
        getPolicyById(id);
      }
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getDetails = async () => {
    setLoaderhelper(true);
    try {
      //  fix me: PASAR AL CONTEXT Y AL REDUCER
      const accessoriesData = await getAccesories(state.vehicle_id);
      setDetails(accessoriesData.data);
      setLoaderhelper(false);
    } catch (error) {
      setDialog(true);
      setLoaderhelper(false);
    }
  };

  return Object.keys(policy).length ? (
    <>
      <Box display={loading || loadingHelper ? 'block' : 'none'}>
        <Loader
          action={
            loadingHelper
              ? 'Cargando el detalle de la cobertura'
              : 'Cargando póliza'
          }
        ></Loader>
      </Box>

      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Ups, ha ocurrido un error!</Typography>
            <Box my={2}>
              <Typography>
                Hubo un error al solicitar los datos de la cobertura, espere un
                momento e intente nuevamente.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SubHeader
        content={
          <>
            <Typography variant="h6" color="primary">
              Póliza {policy.number}
            </Typography>{' '}
            <Typography variant="caption">
              Es el documento principal del seguro donde se detalla la
              cobertura.
            </Typography>
          </>
        }
        actions={<SendEmail documentType={'policy'}></SendEmail>}
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11} sm={11} lg={8}>
          {/* VEHCILE INFO */}
          <Grid container>
            <Grid item xs={12} sm={6} md={4}>
              <Box my={2}>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  Vehículos
                </Typography>
              </Box>
              <Box display={'flex'} flexDirection={'column'}>
                {policy.vehicles
                  ? policy.vehicles.map((vehicle: any) => (
                      <Link
                        key={vehicle.id}
                        component={RouterLink}
                        to={'/documentation/vehicle/details/' + vehicle.id}
                        variant="body2"
                        color="secondary"
                      >
                        {vehicle.brand +
                          ' ' +
                          vehicle.model.split(' ')[0] +
                          ' ' +
                          vehicle.year +
                          ' / ' +
                          vehicle.license_plate}
                      </Link>
                    ))
                  : null}
              </Box>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Box my={2}>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  Vencimiento de póliza
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2">
                  {getFormattedDate(policy.expires_at)}
                </Typography>
              </Box>
            </Grid>
            {Number(policy?.vehicles[0].insured_amount) ? (
              <Grid item xs={6} sm={6} md={4}>
                <Box my={2}>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    Suma asegurada
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2">
                    $
                    {Number(policy.vehicles[0].insured_amount).toLocaleString(
                      'es',
                      {
                        minimumFractionDigits: 0,
                      }
                    )}
                  </Typography>
                </Box>
              </Grid>
            ) : null}
            <Grid item xs={6} sm={6} md={4}>
              <Box my={2}>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  Tipo de cobertura
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2">
                  {policy?.vehicles[0].coverage}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* DETAILS */}
          <Grid container>
            <Grid item xs={12}>
              <Box my={2}>
                <ButtonBase
                  disabled={details.length > 0 ? true : false}
                  onClick={getDetails}
                >
                  <Typography variant="body2" color="secondary">
                    Ver detalle de cobertura
                  </Typography>
                </ButtonBase>
              </Box>
              <List aria-label="detalles">
                {details &&
                  details.map((accesory: any, index: number) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <OkIcon />
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant="body2">{accesory}</Typography>
                        }
                      />
                    </ListItem>
                  ))}
              </List>
              {/* {details.length > 4 ? (
                <Box display="flex" justifyContent="flex-end">
                  {!showMore ? (
                    <Button onClick={() => setShowMore(true)} color="secondary">
                      + Ver más
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      onClick={() => setShowMore(false)}
                    >
                      - Ver menos
                    </Button>
                  )}
                </Box>
              ) : null} */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : null;
};

export default Policy;
